import { DataCache, QueryResultsRelationship, SharedKeyRelationship } from 'lib/DataCache';
import { PCCache, PCCollection } from 'data/PCCache';
import { BerthProfileResponse } from 'data/models/BerthProfileResponse';

export class BerthProfileCache extends DataCache {
    BerthProfileResponses = PCCollection(BerthProfileResponse);

    constructor(data : PCCache) {
        super();

        new SharedKeyRelationship   (this.BerthProfileResponses, data.Berths,            r => r.Berth, null);
        new QueryResultsRelationship(this.BerthProfileResponses, data.BerthAmenityTypes, r => r.Ref && r.Ref.AmenityTypes);
        new QueryResultsRelationship(this.BerthProfileResponses, data.BerthCapabilities, r => r.Ref && r.Ref.Capabilities);
        new QueryResultsRelationship(this.BerthProfileResponses, data.Organizations,     r => r.Ref && r.Ref.Organizations);
        new QueryResultsRelationship(this.BerthProfileResponses, data.Ports,             r => r.Ref && r.Ref.Ports);
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/berthprofile/cache.ts